import traceActionsCreator from '../traceActionsCreator'

export const getRandomFunFactServiceName = 'FunFact/getRandomFunFact'
export const getRandomFunFactTraceActions = traceActionsCreator(
  getRandomFunFactServiceName
)
